import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Container,
  makeStyles,
  Typography,
  LinearProgress
} from '@material-ui/core';

import { actions, CONSTANTS } from 'src/redux';
import Page from 'src/components/Page';
import Results from './Results';
import Toolbar from './Toolbar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const EbookListView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState('');
  const { listEbook } = useSelector((state) => state.ebook);

  const handleRemove = (id) => dispatch(actions.ebook.deleteEbook.remove(id));

  const handleChangePage = (newPage) => {
    const actualPage = newPage + 1;
    setPage(actualPage);
    dispatch(actions.ebook.listEbook.list(actualPage, query));
  };

  const handleSearch = () => dispatch(actions.ebook.listEbook.list(1, query));

  useEffect(() => {
    dispatch(actions.ebook.listEbook.list(page, query));
  }, []);

  return (
    <Page className={classes.root} title="EbookListView">
      <Container maxWidth={false}>
        <Toolbar
          onChange={(searchValue) => setQuery(searchValue)}
          onSubmit={() => handleSearch()}
        />
        <Typography color="textPrimary" gutterBottom variant="h3">
          E-books Biblioteca
        </Typography>
        {listEbook.status === CONSTANTS.STATUS.DONE ? (
          <Box mt={3}>
            <Results
              ebooks={listEbook.ebooks}
              page={page - 1}
              totalEbooks={listEbook.totalEbooks}
              onRemove={handleRemove}
              onChangePage={handleChangePage}
            />
          </Box>
        ) : (
          <LinearProgress />
        )}
      </Container>
    </Page>
  );
};

export default EbookListView;
